import { LIST_FILTER } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case LIST_FILTER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case LIST_FILTER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case LIST_FILTER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
